import { render } from "./TextLayer.vue?vue&type=template&id=3ae37e6b&scoped=true"
import script from "./TextLayer.vue?vue&type=script&lang=js"
export * from "./TextLayer.vue?vue&type=script&lang=js"

import "./TextLayer.vue?vue&type=style&index=0&id=3ae37e6b&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ae37e6b"]])

export default __exports__